/**
 * @author Yaochao
 * @date 2021/7/9 7:49
 * @description 搜索面板组件
 */
import React, {forwardRef, useImperativeHandle, useState} from 'react'
import {Button} from "antd";

/**
 * 搜索面板组件this.props.children 给组件传参
 * @param onOk 筛选触发事件
 * @param onReset 重置触发事件
 * @param btnBlock 按钮折行，默认false
 * @param otherBtns 在筛选和重置按钮之后添加button
 * @param linkage Boolean值，是否联动查询，当为true时，不显示筛选重置按钮，任何查询项发生改变都会触发查询
 * @param onChange linkage=true时，如果参数发生变化的回调
 * @param hideBtns Boolean值，是否隐藏按钮，当为true时，隐藏按钮onOk和onReset方法都将失效
 * @param vertical Boolean值，是否垂直显示，当为true时，垂直显示
 * @returns {*}
 * @constructor
 */
const ZkSearchGroup = forwardRef((props, ref) => {
    const [searchParams, setParams] = useState({});
    const [resetKeys, setResetKeys] = useState([]);
    const [defaultParams, setDefaultParams] = useState({});
    const {className: className, onOk: onOk, onChange: onChange, onReset: onReset, btnBlock: btnBlock, otherBtns: otherBtns, linkage: linkage, hideBtns: hideBtns, vertical: vertical} = props;

    useImperativeHandle(ref, () => ({
        getParams: getParams,
        resetByKeys: resetByKeys,
        clear: clear
    }));

    /**
     * 获取当前参数
     * @returns {{}}
     */
    function getParams() {
        return JSON.parse(JSON.stringify(searchParams));
    }

    /**
     * 通过组件的valueKey重置组件的值
     * @param keys
     */
    function resetByKeys(keys) {
        if (keys) {
            let success = false;
            for (let i in keys) {
                let key = keys[i];
                if (searchParams.hasOwnProperty(key) && defaultParams.hasOwnProperty(key)) {
                    success = true;
                    searchParams[key] = defaultParams[key]
                }
            }
            if (success) {
                setParams(searchParams);
                setResetKeys(keys);
            }
        }
    }

    /**
     * 子组件value变化时的回调
     * @param params
     */
    function setSearchParams(params) {
        Object.assign(searchParams, params);
        if (linkage && onChange) {
            onChange({...searchParams});
        }
    }

    /**
     * 接受子组件设置的默认值
     * @param params
     */
    function setDefaultSearchParams(params) {
        for (let key in params) {
            if (defaultParams.hasOwnProperty(key)) {
                return
            }
        }
        Object.assign(defaultParams, params);
        for (let key in defaultParams) {
            if (searchParams.hasOwnProperty(key)) {
                continue
            } else {
                searchParams[key] = defaultParams[key]
            }
        }
    }

    /**
     * 处理onOk
     */
    function doOk() {
        if (onOk) {
            let params = JSON.parse(JSON.stringify(searchParams));
            params['queryID'] = Math.random();
            onOk(params);
        }
    }

    /**
     * 获取子组件的所有key值
     * @returns {*[]}
     */
    function getChildrenValueKeys() {
        return React.Children.map(props.children, child => {
            return child.props.valueKey
        })
    }

    /**
     * 处理onReset
     */
    function doReset() {
        if (onReset) {
            let params = JSON.parse(JSON.stringify(defaultParams));
            params['queryID'] = Math.random();
            onReset(params);
            setParams(params);
            setResetKeys(getChildrenValueKeys())
        }
    }


    function clear() {
        let params = JSON.parse(JSON.stringify(defaultParams));
        setParams(params);
        setResetKeys(getChildrenValueKeys())
    }

    return (
        <ul className={`searchGroup ${vertical ? 'searchGroup-vertical' : ''} ${className ? className : ''}`}>
            {
                React.Children.map(props.children, child => {
                    return React.cloneElement(child, {
                        setSearchParams: setSearchParams,
                        setDefaultSearchParams: setDefaultSearchParams,
                        resetKeys: resetKeys,
                        linkage: linkage
                    });
                })
            }
            {
                (hideBtns) ? '' : <li className={btnBlock ? 'sg-item btnBlock' : 'sg-item'}>
                    {
                        onOk ? <Button type={'primary'} onClick={doOk}>筛选</Button> : ''
                    }
                    {
                        onReset ? <Button className={'reset'} onClick={doReset}>重置</Button> : ''
                    }
                    {
                        otherBtns
                    }
                </li>
            }
        </ul>
    )
});

export default ZkSearchGroup
